import { render } from "./Translator.vue?vue&type=template&id=ba818468"
import script from "./Translator.vue?vue&type=script&lang=js"
export * from "./Translator.vue?vue&type=script&lang=js"
script.render = render

export default script